// src/reducers/cloverReducers.js
import {
	CLOVER_LOGIN_REQUEST,
	CLOVER_LOGIN_SUCCESS,
	CLOVER_LOGIN_FAIL,
} from '../actions/cloverActions'

export const cloverLoginReducer = (state = {}, action) => {
	switch (action.type) {
		case CLOVER_LOGIN_REQUEST:
			return { loading: true }
		case CLOVER_LOGIN_SUCCESS:
			return { loading: false, cloverData: action.payload }
		case CLOVER_LOGIN_FAIL:
			return { loading: false, error: action.payload }
		default:
			return state
	}
}
